(function () {
  function bindMobileSubnav(page) {
    const toggle = page.querySelector('.flightxfj-list-mobilemenuaName');
    const menu = page.querySelector('.flightxfj-list-mobilemenu > ul');
    if (!toggle || !menu) return;

    toggle.addEventListener('click', () => {
      const open = menu.classList.toggle('is-open');
      toggle.classList.toggle('is-open', open);
    });
  }

  function initSwipers(page) {
    if (!window.Swiper) return;
    page.querySelectorAll('.swiper-container').forEach((el) => {
      if (el.swiper) return;
      try {
        const parent = el.closest('.prodt21-lr');
        const config = {
          slidesPerView: 1,
          loop: false,
          observer: true,
          observeParents: true,
        };
        if (parent) {
          const next = parent.querySelector('.jt2');
          const prev = parent.querySelector('.jt1');
          if (next && prev) {
            config.nextButton = next;
            config.prevButton = prev;
          }
        }
        new window.Swiper(el, config);
      } catch (_) {}
    });
  }

  function initProductLandingPage() {
    const page = document.querySelector('.cs-product-landing-page');
    if (!page) return;

    page.addEventListener('click', (event) => {
      const menuLeft = event.target.closest('.flightxfj-list-menuLeft');
      if (menuLeft) {
        window.scrollTo({ top: 0, behavior: 'auto' });
      }
    });

    bindMobileSubnav(page);

    if (window.WOW) {
      try {
        new window.WOW({ live: false }).init();
      } catch (_) {}
    }

    initSwipers(page);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductLandingPage);
  } else {
    initProductLandingPage();
  }
})();
